<template>
  <div class="detail">
    <p class="userInfo">基本经营信息</p>
    <table-manager :tableData="formData" :disable="true"></table-manager>
    <table-temp
      title="资金已投向情况"
      :flag="1"
      :tableData="publishData"
      :columnData="publishConf"
      :isEdit="false"
      :showSummary="true"
      :summaryMethod="getSummaries"
    ></table-temp>
    <table-temp
      title="年内拟新增投资情况"
      :flag="1"
      :tableData="inToPublishData"
      :columnData="inToPublishConf"
      :isEdit="false"
      :showSummary="true"
      :summaryMethod="getSummariesTwo"
    ></table-temp>
    <table-temp
      title="企业重大变更事项"
      :flag="1"
      :tableData="updataData"
      :columnData="updataConf"
      :isEdit="false"
    ></table-temp>
    <div class="info">
      <p class="userInfo">信息表</p>
      <div class="downReport">
        <span class="downText">{{ reportName }}.doc</span>
        <el-button
          type="primary"
          plain
          class="download"
          @click="download"
          style="font-size: 14px"
          >下载</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import TableTemp from "@table/table";
import TableManager from "./components/AgencyTable";

import { step2Agency, step3Agency } from "@/conf/Report-angency";
import { step4 } from "@/conf/Report-manager";

import { getReportDetail, downloadInfo } from "common/js/api";

export default {
  components: {
    TableManager,
    TableTemp,
  },

  data() {
    return {
      formData: {},
      codeId: this.$route.query.codeId,
      // 已发行
      publishData: [],
      publishConf: step2Agency,
      // 拟发行
      inToPublishData: [{ id: 1 }],
      inToPublishConf: step3Agency,
      //变更事项
      updataData: [],
      updataConf: step4,
      reportName: "",
    };
  },

  mounted() {
    this.getData();
  },

  methods: {
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => {
          if (column.property === "capitalInvested") {
            return Number(item[column.property]);
          }
        });
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2) + "";
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    getSummariesTwo(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => {
          if (column.property === "investeCapital") {
            return Number(item[column.property]);
          }
        });
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index].toFixed(2) + "";
        } else {
          sums[index] = "";
        }
      });

      return sums;
    },
    async getData() {
      const res = await getReportDetail(this.codeId);
      this.formData = res.result.basic;
      this.publishData = res.result.invested;
      this.publishData.map((item) => {
        item.p2p === true ? (item.p2p = "是") : (item.p2p = "否");
      });
      this.inToPublishData = res.result.preInveste;
      this.updataData = res.result.change;
      this.reportName = this.formData.quarterReportName;
    },

    async download() {
      await downloadInfo(this.codeId);
    },
  },
};
</script>

<style scoped>
.title {
  font-size: 24px;
  color: #0f1824;
}
.downText {
  background: #eff1f5 !important;
  display: inline-block;
  width: 250px;
  height: 32px;
  vertical-align: bottom;
  text-align: center;
  line-height: 32px;
}
.downReport {
  margin-top: 20px;
}
.detail {
  background: #ffffff;
  border-radius: 4px;
  box-shadow: 0px 4px 12px 0px #cccccc80;
  padding: 20px;
}
</style>
